import { cn } from '@/lib/cn'

/**
 * Video embeds inside MDX — 18 across the corpus, 15 Loom (via Embedly) and
 * 3 YouTube.
 *
 * Webflow shipped these as raw iframes. `loading="lazy"` matters here: a
 * support doc can carry six, and the originals all loaded eagerly.
 */
export function VideoEmbed({
  src,
  title = 'Embedded video',
  className,
}: {
  src: string
  title?: string
  className?: string
}) {
  const url = src.startsWith('//') ? `https:${src}` : src
  return (
    <div className={cn('relative aspect-video w-full overflow-hidden rounded-lg', className)}>
      <iframe
        src={url}
        title={title}
        loading="lazy"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
        allowFullScreen
        className="absolute inset-0 h-full w-full border-0"
      />
    </div>
  )
}
